
function Title() {
  return (
    <div className="flex justify-center items-center mt-[20px] mb-[15px] gap-[5px]">
      <span className="w-[125px] border border-[rgba(255, 255, 255, 0.4)]  rounded" />
      <h1 className=" w-[87px] text-center text-white text-base  font-inter ">
        ROLL CRAFT
      </h1>
      <span className="w-[125px] border border-[rgba(255, 255, 255, 0.4)] rounded" />
    </div>
  );
}

export default Title;
